import { useState } from "react";

const stats = [
  { value: "1280+", label: "累计追踪事件" },
  { value: "3400+", label: "已记录反转节点" },
  { value: "24h", label: "全天候滚动更新" },
  { value: "92%", label: "读者认为还原度高" },
];

const heroTags = ["片酬争议", "选品翻车", "转会风波", "品牌道歉", "剪辑争议", "创始人公开信"];

export default function Hero() {
  const [query, setQuery] = useState("");

  const search = (e: React.FormEvent) => {
    e.preventDefault();
    const feed = document.querySelector("#feed");
    if (feed) {
      window.scrollTo({ top: (feed as HTMLElement).offsetTop - 70, behavior: "smooth" });
      window.setTimeout(() => {
        const input = document.querySelector('input[aria-label="搜索事件关键词"]') as HTMLInputElement | null;
        if (input) {
          input.focus();
          if (query) input.value = query;
        }
      }, 300);
    }
  };

  return (
    <section id="top" className="relative overflow-hidden bg-background-100">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.12]"
        style={{
          backgroundImage:
            "radial-gradient(oklch(var(--primary-500)) 1px, transparent 1px)",
          backgroundSize: "26px 26px",
        }}
        aria-hidden="true"
      />
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-4 md:px-6 py-14 md:py-20 lg:grid-cols-[1.15fr_0.85fr]">
        <div className="relative">
          <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 text-xs font-bold text-primary-700">
            <i className="ri-flashlight-fill" />
            事件发酵 · 持续更新 · 反转再反转
          </p>
          <h1 className="font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl">
            一个吃瓜现场，
            <br />
            从<b className="text-primary-600">发酵</b>到<b className="text-accent-600">反转</b>的全貌
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            爆炸瓜专注<span className="font-bold text-foreground-900">热点事件发酵追踪</span>，持续更新每个事件的后继进展。
            无论故事反转再反转，我们都不放过任何关键节点，帮你理清整条完整的瓜点脉络。
          </p>

          <form onSubmit={search} className="mt-7 flex max-w-lg flex-col gap-3 sm:flex-row">
            <div className="relative flex-1">
              <i className="ri-search-line pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 text-base text-foreground-400" />
              <input
                type="text"
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                placeholder="搜索你想追的事件关键词…"
                aria-label="搜索事件关键词"
                className="w-full rounded-md border border-background-300 bg-background-50 py-3 pl-10 pr-3 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              立即开瓜
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center gap-2">
            <span className="text-xs font-medium text-foreground-500">今日热搜：</span>
            {heroTags.map((t) => (
              <button
                key={t}
                onClick={() => {
                  setQuery(t);
                  const feed = document.querySelector("#feed");
                  if (feed) window.scrollTo({ top: (feed as HTMLElement).offsetTop - 70, behavior: "smooth" });
                }}
                className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-foreground-700 transition-colors hover:bg-secondary-200"
              >
                #{t}
              </button>
            ))}
          </div>
        </div>

        {/* right stats card panel */}
        <div className="relative">
          <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8">
            <div className="flex items-center justify-between">
              <h2 className="font-heading text-lg font-bold text-foreground-950">追瓜面板</h2>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-2.5 py-1 text-xs font-bold text-primary-700">
                <span className="h-1.5 w-1.5 animate-pulseDot rounded-full bg-primary-500" />
                LIVE
              </span>
            </div>
            <div className="mt-5 grid grid-cols-2 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-xl bg-background-100 p-4">
                  <p className="font-heading text-2xl font-black text-primary-600 md:text-3xl">
                    {s.value}
                  </p>
                  <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
                </div>
              ))}
            </div>
            <div className="mt-5 flex items-start gap-3 rounded-xl border border-background-200 bg-background-50 p-4">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-eye-line text-lg" />
              </span>
              <div>
                <p className="text-sm font-bold text-foreground-900">全网热度实时汇总</p>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                  聚合热搜与社区讨论，第一时间捕捉正在升温的瓜点，不再后知后觉。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}